export const setCurrentGallery = (payload) => (dispatch) => {
  dispatch({ type: 'set_current_gallery', payload });
};
